const spanish = {
  steps: {
    EmailVerification: 'Verificación de E-mail',
    RequestAccess: 'Solicitud de Acceso',
    UserInfo: 'Información de contacto',
    SelectCompany: 'Seleccionar Compañía',
    BusinessInfo: 'Información de la Compañía',
    Diversity: 'Información sobre Diversidad',
    Products: 'Productos y Servicios',
    Login: 'Información para Inicio de Sesión'
  },
  backButtonLabel: 'Atrás',
  continueButtonLabel: 'Continuar',
  affirmativeLabel: 'Si',
  negativeLabel: 'No',
  expandIconTooltip: 'Expandir',
  collapseIconTooltip: 'Contraer',
  emailCheck: {
    languageLabel: 'Seleccione el idioma',
    validEmail: 'Por favor ingrese un e-mail válido',
    enterEmail: 'Ingrese su e-mail',
    welcome: ''
  },
  emailValidationCode: {
    emailValidationTitle:
      'Un e-mail ha sido enviado a {email} con un código de verificación. Por favor ingrese el código abajo.',
    termsOfUse: 'Términos de uso',
    aknowledge: `El uso que le de a este sitio se rige por los siguientes {terms}. Haciendo click en el botón "Continuar", usted confirma que ha leído estos Términos de Uso y acepta que, cada vez que use el sitio, estará sujeto a dichos Términos a los que podrá acceder a través del enlace(s) en la página de login.`,
    validationCodeLabel: 'Código de verificación',
    sendCodeLabel: 'Enviar Código',
    resendCodeLabel: 'Volver a enviar Código',
    validationErrorMessage: 'Por favor ingrese el código de verificación recibido!',
    incorrectValidationCode: 'Código de verificación incorrecto',
    userNotAllowToProceedMsg: 'Hay una cuenta inactiva asociada a este e-mail. Por favor contacte',
    paSupportEmail: 'support@poweradvocate.com',
    reSentLabel: 'Su código de verificación ha sido enviado de nuevo',
    modalActiveAccount: 'Gracias por registrarse. Una cuenta activa existe con el e-mail que ingresó',
    modalEmailExistsText: 'Las siguientes cuentas ya existentes han sido encontradas con el e-mail {email}.',
    modalEmailExistsGuide: 'Por favor escoja una cuenta existente o cree una nueva para una compañía diferente.',
    newUserAccountLabel: 'Crear Nueva cuenta'
  },
  requestAccess: {
    helpText:
      'Para solicitar acceso a este evento de oferta, escriba sus motivos abajo y de click en continuar. Su solicitud de acceso será aprobada o negada por el coordinador del evento y recibirá más instrucciones vía e-mail',
    textAreaLabel: 'Motivos para la solcitud de acceso',
    modalEmailNotInvitedText: [
      'Su dirección de correo electrónico no coincide con la persona invitada inicialmente, posiblemente porque la invitación fue reenviada a usted',
      'Por favor haga click en "Cancelar" para ingresar una dirección de correo electrónico diferente o haga click en "Ok" para completar el proceso de configuración de su cuenta',
      'Su solicitud de acceso será aprobada o negada por el {role} y usted recibirá más instrucciones vía e-mail.'
    ],
    eventCoordinator: 'Coordinador de Eventos',
    portalOwner: 'Propietario del Portal',
    contractOwner: 'Propietario del Contrato',
    modalCancelButton: 'Cancelar',
    modalOkButton: 'Ok',
    modalLoginButton: 'Login'
  },
  userInfo: {
    salutation: [
      { label: '----', value: '' },
      { label: 'Sx.', value: 'Mx.' },
      { label: 'Sr.', value: 'Mr.' },
      { label: 'Sra.', value: 'Mrs.' },
      { label: 'Srta.', value: 'Ms.' },
      { label: 'Dr.', value: 'Dr.' }
    ],
    firstName: 'Nombres',
    lastName: 'Apellidos',
    workPhone: 'Teléfono de la Oficina',
    jobTitle: 'Cargo',
    timeZone: 'Seleccione la zona horaria*',
    reStart: 'Comenzar de nuevo'
  },
  companySelection: {
    helpText: 'Busque su compañía en nuestra base de datos. Si no existe, agréguela.',
    companySearchLabel: 'Seleccione la compañía',
    locationControlsHelpText: 'Por favor complete los siguientes campos',
    siteName: 'Nombre del Sitio',
    address1: 'Dirección Línea 1',
    address2: 'Dirección Línea 2',
    country: 'País',
    city: 'Ciudad',
    stateProvince: 'Estado o Provincia',
    zip: 'Zip / Código Postal',
    phoneNumber: 'Teléfono del Sitio',
    siteTypeCode: 'Tipo de Sitio',
    companyNotFound: '¿La Compañía "{text}" no está en la lista? Haga click aquí para agregarla.',
    tableCompanyNotFound: 'La Compañía no tiene ubicaciones. Por favor agregue una nueva ubicación abajo.',
    tableTitle: 'Seleccione una de las ubicaciones existentes',
    tableSelect: 'Seleccionar',
    tableSiteName: 'Nombre del sitio',
    tableAddress: 'Dirección',
    tableStateProvince: 'Estado/Provincia',
    tableZip: 'Zip/Código Postal',
    tablePhone: 'Teléfono',
    loadingLabel: 'Obteniendo las ubicaciones de la compañía',
    radioLabel: '¿Ubicación no listada? Agregue una nueva ubicación',
    companyDuplicatedName: 'Este nombre de empresa ya existe. Seleccione la empresa existente o actualice el nombre.',
    sortingLabelAlpha: 'Ordene las empresas alfabéticamente {sortOption}',
    sortingLabelUsers: 'Ordene las empresas por número de usuarios activos {sortOption}',
    sortingLabelRelevancy: 'Restablecer ordenar',
    sortAscending: 'de manera ascendente',
    sortDescending: 'de manera descendente',
    activeAccountsLabel: 'active accounts',
    domainSearchLabel:
      'Encontramos la siguiente lista de empresas relacionadas con el dominio de su dirección de correo electrónico: {emailAddress}',
    errorCompanyAlreadyRegistered:
      "Esta compañía tiene una cuenta de usuario existente con este e-mail. Por favor presione click en 'Atrás' y selecciónela."
  },
  companyBio: {
    companyLegalName: 'Nombre Legal de la Compañía',
    companyDoingBusinessAs: 'Nombre Comercial',
    companyParentCompany: 'Compañía Matriz (si aplica)',
    yearCompanyWasFounded: 'Año de fundación',
    numberOfPermanentEmployees: 'Número de empleados permanentes',
    supplierCompanyOwnership: 'Tipo de Propiedad de la Compañía*',
    supplierCompanyOwnershipOptions: [
      { label: 'Propiedad Privada', value: 'Privately Owned' },
      { label: 'Propiedad Pública', value: 'Publicly Owned' },
      { label: 'Propiedad Gubernamental', value: 'Government Owned' }
    ],
    unionizedCompany: 'La Compañía está sindicalizada',
    companyPhoneNumber: 'Teléfono de la Compañía',
    companyWebsite: 'Sitio Web de la Compañía',
    errorCompanyWebsite: 'Por favor ingrese una URL válida',
    companyEmailAddress: 'E-mail de la Compañía',
    errorEmailAddress: 'Por favor ingrese un e-mail válido',
    companyTaxIdNumber: 'Número de identificación de impuestos de la Compañía (EIN)',
    errorTaxIdNumber: 'La identificación de impuestos debería tener 9 dígitos',
    dunsNumber: 'Número DUNS de la Compañía',
    errorDunsNumber: 'El número DUNS debería tener 9 dígitos',
    primaryNAICSCode: 'Código NAICS primario de la Compañía',
    secondaryNAICSCode: 'Código NAICS secundario de la Compañía',
    errorNAICSCode: 'Código NAICS debería tener entre 2 y 6 dígitos',
    annualRevenueLabel: 'Ingreso anual para {newAnnualRevenue} (USD)'
  },
  diversity: {
    radioGroupLabel: '¿Tiene una clasificación de Diversidad?',
    errorDiversityList: 'Hubo un error, intente de nuevo más tarde',
    errorUploadingFile: 'Error cargando archivo, intente de nuevo más tarde',
    errorRequiredField: '*Campo requerido',
    errorForbiddenCharacters: `El nombre del archivo no debe incluir caracteres prohibidos: < > + & # ' / \\ * ? | "`,
    errorPermitedTypeFile: 'Tipos de archivo permitidos: jpg, jpeg, gif, png, bmp, pdf, doc, docx',
    errorDates: 'Fecha de inicio no puede ser posterior a la fecha de expiración.',
    permitedTypeFileTooltip:
      'Cargar Certificados - Tipos de archivo permitidos: jpg, jpeg, gif, png, bmp, pdf, doc, docx',
    tableColumns: [
      { id: 'classification', label: 'Clasificación de Diversidad' },
      { id: 'document', label: 'Certificado de Diversidad', align: 'center' },
      { id: 'certificate', label: 'ID del certificado', align: 'center' },
      { id: 'startDate', label: 'Fecha de inicio', align: 'center' },
      { id: 'expDate', label: 'Fecha de expiración', align: 'center' }
    ],
    note:
      'NOTA: Esta información puede ser actualizada después de completar el registro haciendo login en la plataforma y click en el enlace de Diversidad',
    modalText: 'Por favor confirme que va a remover el archivo: {fileName}',
    modalCancelButton: 'Cancelar',
    modalDeleteButton: 'Eliminar'
  },
  productsServices: {
    searchPlaceholder: 'Buscar...',
    cancelIconTooltip: 'Cancelar',
    selectedProductsListTitle: 'Productos y Servicios seleccionados',
    addProductTooltip: 'Agregar Producto',
    removeProduct: 'Remover Seleccionado'
  },
  confirmation: {
    helperText: 'Ingrese un nombre de usuario y una contraseña',
    submitButtonText: 'Enviar e Ingresar',
    userNameError: 'El nombre de usuario debe tener al menos {0} caracteres',
    passwordError: 'La contraseña debe tener al menos {0} caracteres con 1 mayúscula, 1 minúscula, 1 carácter especial (excepto @) y 1 número',
    passwordConfirmationError: 'Las contraseñas no coinciden',
    usernameLabel: 'Nombre de Usuario',
    passwordnameLabel: 'Contraseña',
    confirmationPassLabel: 'Confirmar Contraseña',
    usernameTaken: 'Nombre de usuario ya está en uso',
    successResponse: 'Proveedor registrado con éxito',
    errorResponse:
      'No podemos guardar su registro. Inténtalo de nuevo. Si el problema continúa, comuníquese con support@poweradvocate.com.'
  },
  common: {
    tagInstructionPrimary: 'Estos datos han sido generados de un registro previo de su compañía el {taggedDate}',
    tagInstructionSecondary: 'Por favor revise todos los campos antes de seleccionar'
  },
  footer: {
    poweredBy: 'Desarrollado por ',
    rightsReserved: 'Todos los derechos reservados',
    termsOfUse: 'Términos de Uso',
    privacyStatement: 'Declaración de Privacidad',
    contactSupport: 'Contacte a Soporte'
  },
  registrationLinkExpired: {
    headerText: 'Registro Expirado',
    title: 'El registro para este evento ya expiró',
    description: 'De igual manera puede registarse y crear una cuenta para oportunidades futuras, haga click ',
    here: 'aqui'
  }
};

export default spanish;
